export const text = {
  Box: "Box",
  AddAssetCategory: "Middel categorie toevoegen",
  AddAsset: "Middel toevoegen",
  AddBookAsset: "Boek middel",
  AssetCategory: "Middel categorie",
  AssetList: "Middel lijst",
  BookAsset: "Middel boeken",
  SelectAssetType: "Selecteer middel type",
  Asset: "Middel",
  Category: "Categorie",
  Pending: "In afwachting",
  Approved: "Goedgekeurd",
  Rejected: "Afgewezen",
  Cancelled: "Geannuleerd",
  Assetaddedsuccessfully: "Middel succesvol toegevoegd",
  AnAssetImageisrequired: "Een middel afbeelding is verplicht",
  Assetupdatedsuccessfully: "Middel succesvol bijgewerkt",
  AnAssetImageisrequired: "Een middel afbeelding is verplicht",
  AssetDeletedsuccessfully: "Middel succesvol verwijderd",
  Assetcategoryaddedsuccessfully: "Middel categorie succesvol toegevoegd",
  AnCategoryImageisrequired: "AEen categorie afbeelding is verplicht",
  Assetcategoryupdatedsuccessfully: "Middel categorie succesvol bijgewerkt",
  AnCategoryImageisrequired: "Een categorie afbeelding is verplicht",
  AssetcategoryDeletedsuccessfully: "Middel categorie succesvol verwijderd",
  BookAssetaddedsuccessfully: "Middel succesvol geboekt",
  BookAssetupdatedsuccessfully: "Middel boeking succesvol bijgewerkt",
  BookAssetDeletedsuccessfully: "Middel boeking succesvol verwijderd",
  AnCategoryTitleisrequired: "Een categorie Titel is verplicht",
};
